import { LinkIcon, ArrowSquareOutIcon } from '@phosphor-icons/react';
import type { EventLinkProps } from '@/lib/types/events.types';
import { EventDetailsContent } from '@/content/EventDetailsContent';

/**
 * EventLink is a presentation component that displays an external link
 * for an event (e.g., virtual meeting link, registration page, etc.)
 *
 * Features:
 * - Opens in a new tab with security attributes
 * - Displays a customizable label with fallback
 * - Styled to match the app's dark theme
 */
export function EventLink({ href, label }: EventLinkProps) {
  const displayLabel = label || EventDetailsContent.eventLink.label;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="event-link"
      className="flex items-center justify-between w-full px-4 py-3 rounded-lg bg-sky-500 min-w-0"
    >
      <div className="flex items-center gap-2 min-w-0 flex-1 overflow-hidden">
        <LinkIcon
          size={20}
          weight="regular"
          className="text-slate-50 flex-shrink-0"
        />
        <span className="text-body max-w-[75%] truncate flex-shrink-0">
          {displayLabel}
        </span>
        <span className="text-body text-blue-500 flex-1 min-w-0 truncate">
          {href.replace('https://', '').replace('http://', '')}
        </span>
      </div>
      <ArrowSquareOutIcon size={18} weight="bold" />
    </a>
  );
}

